import React from 'react'

export default(props) => {
    return(
        <svg width="25" height="25" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0)">
        <path d="M22.5109 3.62516H21.1487V1.2085H18.4243V3.62516H7.52646V1.2085H4.80201V3.62516H3.43978C1.92771 3.62516 0.715332 4.71266 0.715332 6.04183V22.9585C0.715332 24.2877 1.92771 25.3752 3.43978 25.3752H22.5109C24.0094 25.3752 25.2354 24.2877 25.2354 22.9585V6.04183C25.2354 4.71266 24.0094 3.62516 22.5109 3.62516ZM12.9754 7.25016C15.2367 7.25016 17.062 8.86933 17.062 10.8752C17.062 12.881 15.2367 14.5002 12.9754 14.5002C10.7141 14.5002 8.88868 12.881 8.88868 10.8752C8.88868 8.86933 10.7141 7.25016 12.9754 7.25016ZM21.1487 21.7502H4.80201V20.5418C4.80201 18.1252 10.2509 16.796 12.9754 16.796C15.6998 16.796 21.1487 18.1252 21.1487 20.5418V21.7502Z" fill={props.color}/>
        </g>
        <defs>
        <clipPath id="clip0">
        <rect width="29" height="29" fill={props.color}/>
        </clipPath>
        </defs>
        </svg>
    )
}